import script from "./HeaderNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderNav.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderNav.vue?vue&type=style&index=0&id=87d354f0&lang=scss"

const __exports__ = script;

export default __exports__